import React, { PureComponent } from 'react';
import {
  FormControl,
  Box,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core';
import { uuid } from 'utils';
import './radio.scss';

export class CommonRadio extends PureComponent {
  constructor() {
    super();
    this.state = {
      selected: false,
    };
  }

  render() {
    const {
      label,
      value,
      onChange,
      name,
      items,
      errorFlag,
      errorMessage,
    } = this.props;

    return (
      <div className={errorFlag ? 'error' : ''}>
        <FormControl component="fieldset">
          <Box mb="15px">
            <FormLabel component="legend" className="label">
              {label}
            </FormLabel>
          </Box>
          <RadioGroup name={name} value={value} onChange={onChange} row>
            {items.map(({ value, label }) => {
              return (
                <FormControlLabel
                  key={uuid()}
                  value={value}
                  control={<Radio color="primary" />}
                  label={label}
                  labelPlacement="end"
                />
              );
            })}
          </RadioGroup>
          <p className="error-message">{errorMessage}</p>
        </FormControl>
      </div>
    );
  }
}

CommonRadio.defaultProps = {
  placeholder: 'Please Select',
  value: '',
  name: '',
  onChange: () => {},
  fetchSuggestions: () => {},
};
